import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlannerQueryComponent } from './planner-query.component';

import { FeatureFlagResolver } from 'ngx-feature-flag';

const routes: Routes = [{
  path: 'query',
  component: PlannerQueryComponent,
  resolve: {
    featureFlagConfig: FeatureFlagResolver
  },
  data: {
    title: 'Query Tab',
    featureName: 'PlannerQuery'
  }
}];


export class PlannerQueryRoutingModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
